import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledBasicToolbar,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';

export const DashboardHeader = () => {
  const { isDesktop } = useBreakpointsCtx();

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledBasicToolbar>
        <StyledAgioH1
          noWrap
          color="customSecondary.primary.DEFAULT"
          data-testid="dashboard-header-title"
        >
          Risk Monitor
        </StyledAgioH1>
      </StyledBasicToolbar>
    </StyledHeader>
  );
};
